import React, { useMemo } from 'react';
import { useWatchlist } from '../context/WatchlistContext';
import './WatchlistPage.css';

const WatchlistPage = ({ onBack }) => {
  const { watchlist, removeFromWatchlist } = useWatchlist();
  const watchlistData = watchlist;

  const stats = useMemo(() => {
    if (watchlistData.length === 0) {
      return { gainers: 0, losers: 0, total: 0, avgChange: 0 };
    }

    const gainers = watchlistData.filter(stock => (stock.change || 0) > 0).length;
    const losers = watchlistData.filter(stock => (stock.change || 0) < 0).length;
    const total = watchlistData.length;
    const avgChange = watchlistData.reduce((sum, stock) => sum + (stock.changePercent || 0), 0) / total;

    return { gainers, losers, total, avgChange };
  }, [watchlistData]);

  const handleRemove = (symbol) => {
    removeFromWatchlist(symbol);
  };

  return (
    <div className="watchlist-page">
      <header className="watchlist-header">
        <div className="watchlist-header-container">
          <div className="logo">
          <img src="images/Final Font Stocks4U1.png" className="logo-text" />
          </div>
          
          <div className="watchlist-user">
            <button className="watchlist-back-btn" onClick={onBack}>
              ← Back to Dashboard
            </button>
          </div>
        </div>
      </header>

      <main className="watchlist-main">
        <div className="watchlist-container">
          <div className="watchlist-title">
            <h1>My Watchlist</h1>
            <div className="watchlist-info">
              <span className="info-icon">⭐</span>
              <span className="info-text">Track your favorite stocks</span>
            </div>
          </div>

          <div className="watchlist-summary">
            <div className="summary-card">
              <h3>Watchlist Summary</h3>
              <div className="summary-stats">
                <div className="stat-item">
                  <span className="stat-icon">📈</span>
                  <span className="stat-label">Gainers</span>
                  <span className="stat-value positive">{stats.gainers}</span>
                </div>
                <div className="stat-item">
                  <span className="stat-icon">📉</span>
                  <span className="stat-label">Losers</span>
                  <span className="stat-value negative">{stats.losers}</span>
                </div>
                <div className="stat-item">
                  <span className="stat-icon">🎯</span>
                  <span className="stat-label">Total Stocks</span>
                  <span className="stat-value">{stats.total}</span>
                </div>
                <div className="stat-item">
                  <span className="stat-icon">📊</span>
                  <span className="stat-label">Avg Change</span>
                  <span className={`stat-value ${stats.avgChange >= 0 ? 'positive' : 'negative'}`}>
                    {stats.avgChange >= 0 ? '+' : ''}{stats.avgChange.toFixed(2)}%
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="watchlist-table-container">
            <div className="table-header-info">
              <span className="results-count">Showing {watchlistData.length} stocks</span>
              <span className="last-updated">Last updated: Real-time</span>
            </div>

            <div className="watchlist-table">
              <div className="table-row--watchlist table-header-row">
                <div className="table-cell">Symbol</div>
                <div className="table-cell">Name</div>
                <div className="table-cell">LTP</div>
                <div className="table-cell">Change</div>
                <div className="table-cell">Change %</div>
                <div className="table-cell">Volume</div>
                <div className="table-cell">Market Cap</div>
                <div className="table-cell">SIGNALS</div>
                <div className="table-cell">Actions</div>
              </div>

              {watchlistData.length === 0 ? (
                <div className="empty-watchlist">
                  <p>Your watchlist is empty. Click the star icon on any stock to add it here!</p>
                </div>
              ) : (
                watchlistData.map((stock, index) => {
                  const isPositive = (stock.change || 0) >= 0;
                  return (
                    <div key={stock.symbol || index} className="table-row--watchlist stock-row">
                      <div className="table-cell stock-symbol">{stock.symbol}</div>
                      <div className="table-cell stock-name">{stock.name}</div>
                      <div className="table-cell stock-price">₹{stock.ltp ? stock.ltp.toFixed(2) : 'N/A'}</div>
                      <div className={`table-cell stock-change ${isPositive ? 'positive' : 'negative'}`}>
                        {stock.change ? `${stock.change >= 0 ? '+' : ''}${stock.change.toFixed(2)}` : 'N/A'}
                      </div>
                      <div className={`table-cell stock-change-percent ${isPositive ? 'positive' : 'negative'}`}>
                        {stock.changePercent ? `${stock.changePercent >= 0 ? '+' : ''}${stock.changePercent.toFixed(2)}%` : 'N/A'}
                      </div>
                      <div className="table-cell stock-volume">{stock.volume || 'N/A'}</div>
                      <div className="table-cell stock-market-cap">₹{stock.marketCap || 'N/A'} Cr</div>
                      <div className="table-cell stock-chart">
                        <span style={{ color: isPositive ? '#10b981' : '#ef4444', fontSize: '1.2rem', fontWeight: 'bold' }}>
                          {isPositive ? '↑' : '↓'}
                        </span>
                      </div>
                      <div className="table-cell stock-actions">
                        <button className="action-btn remove" onClick={() => handleRemove(stock.symbol)}>Remove</button>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default WatchlistPage;